// extracted by mini-css-extract-plugin
export var joinsec = "styles-module--joinsec--3o9yl";
export var joinsec_bg = "styles-module--joinsec_bg--SNKWf";
export var join = "styles-module--join--26m22";
export var join_txt = "styles-module--join_txt--2-xYp";
export var jointxt = "styles-module--jointxt--IRht5";
export var jointxt_title = "styles-module--jointxt_title--7v-hY";
export var jointxt_subtitle = "styles-module--jointxt_subtitle--2meHE";
export var jointxt_btn = "styles-module--jointxt_btn--326aw";